import { render, staticRenderFns } from "./productDetailsList.vue?vue&type=template&id=75ecf897&scoped=true&"
import script from "./productDetailsList.vue?vue&type=script&lang=js&"
export * from "./productDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./productDetailsList.vue?vue&type=style&index=0&id=75ecf897&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ecf897",
  null
  
)

export default component.exports